import { render, staticRenderFns } from "./LivingOptionsSubsections.vue?vue&type=template&id=4d2eeb45&"
import script from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"
export * from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionsSubsections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports